(function () {
  if(typeof InitOpendateTours !== 'function'){
    var getBaseUrl = function(){
      const currentScript = document.currentScript;
      return new URL(currentScript.src).origin; 
    }

    var createTourTable = function(tourDiv, tourData, baseUrl) {
      const container = document.createElement('div');
      container.className = 'opendate-events-table';
      container.style.width = '100%';

      if (tourData.tour_dates.length === 0) {
        const noEventsDiv = document.createElement('div');
        noEventsDiv.className = 'opendate-no-events';
        noEventsDiv.textContent = 'There are no upcoming events.';
        container.appendChild(noEventsDiv);
      } else {
        const sortedDates = tourData
          .tour_dates
          .sort((a, b) => new Date(a.event_on) - new Date(b.event_on));

        sortedDates.forEach(tourDate => {
          const row = document.createElement('div');
          row.className = 'opendate-event-row';

          // row.addEventListener('click', function(event) {
          //   if (!event.target.closest('.opendate-event-link')) {
          //     window.location.href = tourData.public_landing_page_url;
          //   }
          // });

          const descriptionCells = document.createElement('div');
          descriptionCells.className = 'opendate-event-description-cells';

          const dateCell = document.createElement('div');
          dateCell.className = 'opendate-event-date-cell';

          const [year, month, day] = tourDate.event_on.split('-').map(Number);
          const eventDate = new Date(year, month - 1, day);

          dateCell.textContent = eventDate.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
          }).toUpperCase();
          descriptionCells.appendChild(dateCell);

          const venueCell = document.createElement('div');
          venueCell.className = 'opendate-event-venue-cell';

          const venueName = document.createElement('div');
          venueName.className = 'opendate-event-venue-name';
          venueName.textContent = tourDate.venue_name;

          const venueLocation = document.createElement('div');
          venueLocation.className = 'opendate-event-venue-location';
          venueLocation.textContent = tourDate.city_and_state;

          venueCell.appendChild(venueName);
          venueCell.appendChild(venueLocation);
          descriptionCells.appendChild(venueCell);

          if (tourDate.support_artists && tourDate.support_artists.trim().length > 0) {
            const detailsCell = document.createElement('div');
            detailsCell.className = 'opendate-event-details-cell';
            detailsCell.textContent = `with ${tourDate.support_artists}`;
            descriptionCells.appendChild(detailsCell);
          }

          const linkCells = document.createElement('div');
          linkCells.className = 'opendate-event-link-cells';

          if (tourDate.show_presale_url) {
            const presaleCell = document.createElement('div');
            presaleCell.className = 'opendate-event-link-cell';
            const presaleLink = document.createElement('a');
            presaleLink.href = tourDate.presale_url;
            presaleLink.textContent = 'Presale';
            presaleLink.className = 'opendate-event-link';
            presaleLink.target = '_blank';
            presaleCell.appendChild(presaleLink);
            linkCells.appendChild(presaleCell);
          }

          if (tourDate.show_vip_url) {
            const vipLink = document.createElement('a');
            vipLink.href = tourDate.vip_url;
            vipLink.textContent = 'VIP';
            vipLink.className = 'opendate-event-link';
            vipLink.target = '_blank';
            const vipCell = document.createElement('div');
            vipCell.className = 'opendate-event-link-cell';
            vipCell.appendChild(vipLink);
            linkCells.appendChild(vipCell);
          }

          if (tourDate.show_public_on_sale_url) {
            const linkCell = document.createElement('div');
            linkCell.className = 'opendate-event-link-cell';
            const ticketLink = document.createElement('a');
            ticketLink.href = tourDate.public_on_sale_url;
            ticketLink.target = '_blank';
            

            if (tourDate.event_state === 'Sold Out') {
              ticketLink.textContent = 'Sold Out';
              ticketLink.className = 'opendate-event-link opendate-event-link-sold-out';
            } else {
              ticketLink.textContent = 'Tickets';
              ticketLink.className = 'opendate-event-link';
            }

            linkCell.appendChild(ticketLink);
            linkCells.appendChild(linkCell);
          }

          row.appendChild(descriptionCells);
          row.appendChild(linkCells);
          container.appendChild(row);
        });
      }

      tourDiv.appendChild(container);

      const footer = document.createElement('div');
      footer.className = 'opendate-event-footer';

      const poweredByText = document.createTextNode('Powered by ');
      footer.appendChild(poweredByText);

      const logoLink = document.createElement('a');
      logoLink.href = 'https://www.opendate.io/';
      logoLink.target = '_blank';

      const logo = document.createElement('img');
      logo.src = `${baseUrl}/Alt@3x.png`;
      logo.style.width = '88px';

      logoLink.appendChild(logo);
      footer.appendChild(logoLink);
      container.appendChild(footer);
    }

    var addOpendateStyles = function(){
      if (document.getElementById('opendate-tour-styles')) {
        return;
      }

      const style = document.createElement('style');
      style.id = 'opendate-tour-styles';
      style.textContent = `
        .opendate-events-table {
          font-size: 14px;
          text-align: left;
          width: 100%;
          line-height: 24px;
        }

        .opendate-xhr-error {
          text-align: left;
          padding: 20px;
        }

        .opendate-no-events {
          padding: 20px;
        }

        .opendate-event-row {
          display: flex;
          justify-content: space-between;
          padding: 14px 10px;
          border-bottom: 1px solid rgb(245, 245, 245);
          flex-direction: row;
          gap: 10px;
          // cursor: pointer;
        }

        .opendate-event-row:hover {
          background-color: #f4f9fc;
        }

        .opendate-event-description-cells {
          display: flex;
          flex-direction: column;
          width: 65%;
        }

        .opendate-event-date-cell {
          font-weight: bold;
        }

        .opendate-event-venue-cell {
          display: flex;
          gap: 4px;
        }

        .opendate-event-venue-name {
          width: 60%;
        }

        .opendate-event-venue-location {
          width: 40%;
        }

        .opendate-ticket-link {
          text-decoration: none;
          color: #000;
          font-weight: bold;
        }

        .opendate-event-link-cells {
          display: flex;
        }

        .opendate-event-link-cell {
          display: flex;
          align-items: center;
          margin-left: 9px;
        }

        .opendate-event-link {
          display: inline-block;
          width: 120px;
          box-sizing: border-box;
          font-size: 12px;
          text-decoration: none;
          color: black;
          font-weight: normal;
          padding: 6px 0;
          letter-spacing: 0.5px;
          border: 2px solid black;
          background: white;
          border-radius: 3px;
          text-transform: uppercase;
          text-align: center;
        }

        .opendate-event-link:hover {
          border: 2px solid white;
          background: black;
          color: white;
        }

        .opendate-event-footer {
          font-size: 16px;
          padding: 10px 5px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }

        .opendate-event-footer img {
          margin-left: 8px;
        }

        @media (max-width: 768px) {
          .opendate-event-venue-cell {
            flex-wrap: wrap;
            gap: 0;
          }

          .opendate-event-venue-name, .opendate-event-venue-location {
            width: 100%;
          }

          .opendate-event-link-cells {
            flex-direction: column;
            gap: 10px;
          }

          .opendate-event-link-cell {
            margin-left: 0;
          }
        }

        @media (max-width: 576px) {
          .opendate-events-table {
            text-align: center;
          }

          .opendate-event-row {
            flex-direction: column;
          }

          .opendate-event-description-cells {
            width: 100%;
          }

          .opendate-event-link-cells {
            width: 100%;
            flex-direction: column;
            gap: 10px;
            margin-top: 10px;
            align-items: center;
          }

          .opendate-event-link-cell {
            margin-left: 0;
            width: 100%;
          }

          .opendate-event-link {
            width: 100%;
          }
        }
      `;

      document.head.insertBefore(style, document.head.firstChild);
    }

    window.InitOpendateTours = function(){
      const baseUrl = getBaseUrl();
      const tourDivs = document.querySelectorAll('div[id^="opendate-tour-"]:not([data-loaded])');

      addOpendateStyles();

      tourDivs.forEach(tourDiv => {
        tourDiv.setAttribute('data-loaded', 'true');
        const tourId = tourDiv.id.split('-')[2];

        fetch(`${baseUrl}/public_tours/${tourId}.json`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then(data => {
            createTourTable(tourDiv, data, baseUrl);
          })
          .catch(error => {
            const xhrErrorDiv = document.createElement('div');
            xhrErrorDiv.className = 'opendate-xhr-error';
            xhrErrorDiv.textContent = 'Error loading tour dates';
            tourDiv.appendChild(xhrErrorDiv);
          });
      });
    };
  }

  InitOpendateTours();
})();
